// src/locales/ta/creditNote.js
export const creditNote = {
  // Page titles
  creditNotes: 'கிரெடிட் குறிப்புகள்',
  allCreditNotes: 'அனைத்து கிரெடிட் குறிப்புகள்',
  createCreditNote: 'கிரெடிட் குறிப்பை உருவாக்கு',
  createCreditNoteDescription: 'ஒரு மூல ஆர்டருக்கு எதிராக கிரெடிட் குறிப்பை வழங்கவும்',
  creditNoteDetails: 'கிரெடிட் குறிப்பு விவரங்கள்',
  viewAndManageAllCreditNotes: 'அனைத்து கிரெடிட் குறிப்புகளையும் பார்க்கவும் நிர்வகிக்கவும்',

  // List columns
  creditNoteNumber: 'கிரெடிட் குறிப்பு #',
  customer: 'வாடிக்கையாளர்',
  originalOrder: 'மூல ஆர்டர்',
  sourceType: 'மூலம்',
  amount: 'தொகை',
  balance: 'மீதி',
  appliedAmount: 'பயன்படுத்தப்பட்ட தொகை',
  remainingAmount: 'மீதமுள்ள தொகை',
  reason: 'காரணம்',
  createdBy: 'உருவாக்கியவர்',
  createdAt: 'உருவாக்கப்பட்ட தேதி',
  status: 'நிலை',
  actions: 'செயல்கள்',

  // Status labels — used via t(`creditNote.status_${note.status}`)
  status_issued:    'வழங்கப்பட்டது',
  status_applied:   'பயன்படுத்தப்பட்டது',
  status_cancelled: 'ரத்து செய்யப்பட்டது',

  // Source type labels — used via t(`creditNote.sourceType_${note.sourceType}`)
  sourceType_return:           'திரும்பப் பெறுதல்',
  sourceType_price_adjustment: 'விலை சரிசெய்தல்',
  sourceType_goodwill:         'நல்லெண்ண கிரெடிட்',

  // Form fields
  selectCustomer: 'வாடிக்கையாளரைத் தேர்ந்தெடுக்கவும்',
  allCustomers: 'அனைத்து வாடிக்கையாளர்கள்',
  selectOriginalOrder: 'ஆர்டரைத் தேர்ந்தெடுக்கவும்',
  amountPlaceholder: 'கிரெடிட் குறிப்பு தொகையை உள்ளிடவும்',
  reasonPlaceholder: 'இந்த கிரெடிட் குறிப்புக்கான காரணத்தை உள்ளிடவும்...',
  notes: 'குறிப்புகள்',
  notesPlaceholder: 'இந்த கிரெடிட் குறிப்பு பற்றிய குறிப்புகளைச் சேர்க்கவும்...',

  // Actions
  create: 'கிரெடிட் குறிப்பை உருவாக்கு',
  issueCreditNote: 'கிரெடிட் குறிப்பை வழங்கு',
  save: 'சேமி',
  applyToOrder: 'ஆர்டருக்குப் பயன்படுத்து',
  applyCreditNote: 'கிரெடிட் குறிப்பை பயன்படுத்து',
  cancelCreditNote: 'கிரெடிட் குறிப்பை ரத்து செய்',
  print: 'அச்சிடு',
  printCreditNote: 'கிரெடிட் குறிப்பை அச்சிடு',
  backToCreditNotes: 'கிரெடிட் குறிப்புகளுக்குத் திரும்பு',

  // Confirmations
  confirmApply: 'தேர்ந்தெடுக்கப்பட்ட ஆர்டருக்கு இந்த கிரெடிட் குறிப்பைப் பயன்படுத்தவா?',
  confirmCancel: 'இந்த கிரெடிட் குறிப்பை ரத்து செய்ய விரும்புகிறீர்களா? இந்தச் செயலைச் செயல்தவிர்க்க முடியாது.',
  cancellationReason: 'ரத்து செய்வதற்கான காரணம்',
  cancellationReasonPlaceholder: 'ரத்து செய்வதற்கான காரணத்தை உள்ளிடவும்...',
  applyAmount: 'பயன்படுத்த வேண்டிய தொகை',

  // Filters
  filterByStatus: 'நிலை மூலம் வடிகட்டு',
  filterBySourceType: 'மூலம் வடிகட்டு',
  filterByCustomer: 'வாடிக்கையாளர் மூலம் வடிகட்டு',
  dateFrom: 'தொடக்கம்',
  dateTo: 'முடிவு',
  searchCreditNotes: 'கிரெடிட் குறிப்பு #, வாடிக்கையாளர் மூலம் தேடு...',
  allStatuses: 'அனைத்து நிலைகள்',
  allSourceTypes: 'அனைத்து மூலங்கள்',

  // Success / error messages
  creditNoteCreatedSuccessfully: 'கிரெடிட் குறிப்பு வெற்றிகரமாக உருவாக்கப்பட்டது',
  creditNoteAppliedSuccessfully: 'கிரெடிட் குறிப்பு வெற்றிகரமாக பயன்படுத்தப்பட்டது',
  creditNoteCancelledSuccessfully: 'கிரெடிட் குறிப்பு வெற்றிகரமாக ரத்து செய்யப்பட்டது',
  failedToCreateCreditNote: 'கிரெடிட் குறிப்பை உருவாக்குவதில் தோல்வி',
  failedToApplyCreditNote: 'கிரெடிட் குறிப்பை பயன்படுத்துவதில் தோல்வி',
  failedToCancelCreditNote: 'கிரெடிட் குறிப்பை ரத்து செய்வதில் தோல்வி',
  failedToLoadCreditNotes: 'கிரெடிட் குறிப்புகளை ஏற்றுவதில் தோல்வி',
  failedToLoadCreditNoteDetails: 'கிரெடிட் குறிப்பு விவரங்களை ஏற்றுவதில் தோல்வி',
  someFieldsRequired: 'சமர்ப்பிக்கும் முன் குறிப்பிடப்பட்ட புலங்களை சரிசெய்யவும்',

  // Validation
  customerRequired: 'தயவுசெய்து ஒரு வாடிக்கையாளரைத் தேர்ந்தெடுக்கவும்',
  originalOrderRequired: 'தயவுசெய்து ஆர்டரைத் தேர்ந்தெடுக்கவும்',
  amountRequired: 'தொகை தேவை',
  amountMustBePositive: 'தொகை பூஜ்ஜியத்தை விட அதிகமாக இருக்க வேண்டும்',
  amountExceedsOrderBalance: 'தொகை ஆர்டரின் நிலுவைத் தொகையை மீற முடியாது',
  reasonRequired: 'காரணம் தேவை',
  applyAmountExceedsRemaining: 'பயன்படுத்த வேண்டிய தொகை கிரெடிட் குறிப்பின் மீதமுள்ள தொகையை மீற முடியாது',
  applyAmountExceedsOrderBalance: 'பயன்படுத்த வேண்டிய தொகை தேர்ந்தெடுக்கப்பட்ட ஆர்டரின் நிலுவைத் தொகையை மீற முடியாது',

  // Empty states
  noCreditNotesFound: 'கிரெடிட் குறிப்புகள் எதுவும் இல்லை',
  noCreditNotesFoundDescription: 'மேலும் கிரெடிட் குறிப்புகளைக் காண தற்போதைய வடிகட்டிகளை சரிசெய்யவும்.',
  noCreditNotesYet: 'இதுவரை கிரெடிட் குறிப்புகள் இல்லை.',
  noCreditNotesYetDescription: 'வாடிக்கையாளர் பணத்திரும்பப் பெறுதல்களைக் கண்காணிக்க தொடங்க உங்கள் முதல் கிரெடிட் குறிப்பை உருவாக்கவும்.',
  noCreditNotesMatchFilters: 'உங்கள் தற்போதைய வடிகட்டிகளுக்கு பொருந்தும் கிரெடிட் குறிப்புகள் இல்லை',
  issueFirstCreditNote: 'முதல் கிரெடிட் குறிப்பை வழங்கு',

  na: 'பொருந்தாது',
};
